module.exports = __webpack_public_path__ + "static/media/heart.0c05dc63.png";